enum SignatureAddCertificateDialogFields {
	CERTIFICATE = "certificate",
	PRIVATE_KEY = "private_key",
	PASSWORD = "password"
}

export default SignatureAddCertificateDialogFields;